<template>
	<div class="regionalTranslationTopView">
		<div class="operator_view common_display">
			<div class="operator_view_left">
				<div class="back titleMain_left common_display" @click="onBack" v-if="false">
					<i class="iconfont icon-icon_return" />
					<span class="back_text">{{t('back')}}</span>
				</div>
			</div>
			<div class="operator_view_center common_display">
				<!-- 缩放模块 -->
				<div class="pagePDFScala common_display" v-if="isScalaShow">
					<!-- <div :class="`${ratio == 0.5 ? 'unSelectzoomDiv' : 'zoomDiv'}`" @click="onZoomOut">
						<i class="iconfont icon-icon_reduce" />
					</div>
					<div :class="`${ratio == 3.0 ? 'unSelectzoomDiv' : 'zoomDiv'}`" @click="onZoomIn">
						<i class="iconfont icon-icon_preview" />
					</div> -->
				</div>
				<!-- 页码模块 -->
				<div class="pagePDFMode common_display">
					<input class="pagePDFMode_input" v-model="currentPage" @input="handlePageInput"
						@blur="handlePageBlur"></input>
					<span>{{ `/ ${pages.pageNumber}` }}</span>
				</div>
				<!-- 操作菜单模块 整页不翻译，画矩形开关，画分割线开关 -->
				<div class="regionalOperatorMode common_display">
					<el-tooltip class="box-item" effect="dark" placement="top" style="max-width: 300px; word-wrap: break-word;"
						show-arrow enterable>
						<i class=" iconfont icon-icon_selectpage" @click="operatorActive('pageFlag')"
							:class="{ 'iconfontActive': isPageNotTranslate }"></i>
						<template #content>
							<p style="cursor: pointer;">{{ t('doclingo_regional_whole_page') }}</p>
						</template>
					</el-tooltip>
					<el-tooltip class="box-item" effect="dark" placement="top" style="max-width: 300px; word-wrap: break-word;"
						show-arrow enterable>
						<i class=" iconfont icon-icon_nchecked_n" @click="operatorActive('rectangle')"
							:class="{ 'iconfontActive': currentOperatorType === 'rectangle', 'operator_item': isPageNotTranslate }"></i>
						<template #content>
							<p style="cursor: pointer;">{{ t('doclingo_regional_select_area') }}</p>
						</template>
					</el-tooltip>
					<el-tooltip class="box-item" effect="dark" placement="top" style="max-width: 300px; word-wrap: break-word;"
						show-arrow enterable>
						<i class=" iconfont icon-icon_slice" @click="operatorActive('line')"
							:class="{ 'iconfontActive': currentOperatorType === 'line', 'operator_item': isPageNotTranslate }"></i>
						<template #content>
							<p style="cursor: pointer;">{{ t('doclingo_regional_split') }}</p>
						</template>
					</el-tooltip>



				</div>

			</div>
			<div class="operator_view_right common_display">
				<div class="close" @click="onClose">
					<i class="iconfont icon-icon_close" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang='ts'>

 import {ref,reactive,watch,onMounted,onBeforeUnmount} from "vue";
 import { useI18n } from "vue-i18n";
 const { t, locale } = useI18n();

 import eventBus from "vue3-eventbus";
 import { getDrawing, getAllDrawings } from '@/composables/drawingManager'

 const router = useRouter();
 const route = useRoute();

interface pagesType {
	currentPage: number,
	pageNumber: number,
	allH: number,
}
interface Props {
	pages: pagesType,
	ratio: number,
	isEdit: boolean,
	editPdfJsonStr?: string;
	isProtectArea?: boolean;
	pageFlagStatus?: Record<number, boolean>;
}

const props = withDefaults(defineProps<Props>(), {
	isProtectArea: false
})
const isScalaShow = ref(true);
// 页码相关参数对象
const pages = reactive(props.pages);
// 缩放比
const ratio = ref(props.ratio)
// 当前页面码
const currentPage = ref(props.pages.currentPage)

const currentOperatorType = ref('');   // page: 整页不翻译  rectangle: 矩形   line: 分割线
const lastPage = ref<number | null>(null)

const isPageNotTranslate = ref(false);

function syncProtectAreaPageFlagState(page = Number(currentPage.value)) {
	if (!props.isProtectArea) return
	const selected = Boolean(props.pageFlagStatus?.[page])
	isPageNotTranslate.value = selected
	if (selected) currentOperatorType.value = ''
	lastPage.value = page
}


// 不要混合逻辑，如果编辑状态，则不显示缩放，默认，保持显示, 区域翻译需要缩放，主编辑功能没有缩放功能， 需要补充该功能
watch(() => props.isEdit, (newValue, oldValue) => {
	if (newValue) {
		isScalaShow.value = false
	} else {
		isScalaShow.value = true
	}
})
watch(() => props.pages, (newValue, oldValue) => {
	if (newValue && newValue.currentPage) {
    currentPage.value = newValue.currentPage
    if (props.isProtectArea) {
      syncProtectAreaPageFlagState(newValue.currentPage)
      return
    }
    // 如果页码变了，也触发重置
    if (lastPage.value !== newValue.currentPage) {
      isPageNotTranslate.value = false
      currentOperatorType.value = ''
      lastPage.value = newValue.currentPage
    }
  }
},{
	deep:true,
	// immediate:true
})
watch(() => props.pageFlagStatus, () => {
	syncProtectAreaPageFlagState()
}, {
	deep: true,
	immediate: true
})
watch(() => props.editPdfJsonStr, async (newData) => {
	// 是个json字符串， 需要解析
	if (newData) {
		let firstItem = getPriorityItem(JSON.parse(newData),1)
		if (firstItem?.edit_rect_type =='page'){
			isPageNotTranslate.value = true
		} else if (firstItem?.edit_rect_type == 'area' || firstItem?.edit_rect_type == 'rectangle'){
			isPageNotTranslate.value = false
			currentOperatorType.value = 'rectangle'
		} else if (firstItem?.edit_rect_type == 'line') {
			isPageNotTranslate.value = false
			currentOperatorType.value = 'line'
		}
	}else{
		if (props.isProtectArea && Boolean(props.pageFlagStatus?.[Number(current)])) {
			isPageNotTranslate.value = true
			currentOperatorType.value = ''
			return
		}
		isPageNotTranslate.value = false
		currentOperatorType.value = props.isProtectArea ? '' : 'rectangle'
	}
}, {
	immediate: true,
	deep: true
})
/**
 * 根据优先级获取指定页面的数据项
 * @param data 原始数据对象 
 * @param pageKey 要查询的页面key（如"1"）
 * @returns 匹配到的item对象或undefined
 */
function getPriorityItem(data: Record<string, Array<{
	ignore_type: string;
	data: number[];
	edit_rect_type: 'page' | 'area' | 'rectangle' | 'line';
}>>, pageKey: number) {
	// 1. 获取指定页面的数据数组
	const pageItems = data[pageKey];
	if (!pageItems || !Array.isArray(pageItems)) return undefined;

	// 2. 按优先级查找
	let foundItem = pageItems.find(item => item.edit_rect_type === 'page');
	if (foundItem) return foundItem;

	foundItem = pageItems.find(item => item.edit_rect_type === 'area');
	if (foundItem) return foundItem;

	return pageItems.find(item => item.edit_rect_type === 'line');
}

onMounted(async()=>{
	eventBus.on('deleteItem', deleteItemHandler)
})

const deleteItemHandler = ({type,index})=>{
		console.log('是否监听到删除事件', type,index)
		if (type == 'page' || type == 'pageFlag'){
			if (props.isProtectArea && Number(index) !== Number(currentPage.value)) return
			isPageNotTranslate.value = false
		}
}

onBeforeUnmount(() => {
	eventBus.off('deleteItem', deleteItemHandler)
})

// 定义事件
const emit = defineEmits<{
	(e: 'onBack'): void; //
	(e: 'onClose'): void; //
	(e: 'onZoomOut', payload: { action: string }): void; //
	(e: 'onZoomIn', payload: { action: string }): void; //
	(e: 'operatorActive', payload: { action: string, isCurrentlyFlag?: boolean }): void; //
	(e: 'updatePages', payload: { currentPage: number }): void; //
}>();
// 返回事件，这里的返回，是指返回到主编辑状态。
const onBack = () => {
	emit('onBack');
}
// 关闭当前区域翻译状态。
const onClose = () => {
	emit('onClose');
}
// 缩小事件
const onZoomOut = () => {
	emit('onZoomOut', { action: 'onZoomOut' })
}
// 放大事件
const onZoomIn = () => {
	emit('onZoomIn', { action: 'onZoomIn' })
}


// 选中当前操作项
const operatorActive = (str: string) =>{
	console.log('isPageNotTranslate.value====>>>', isPageNotTranslate.value)
	const current = currentPage.value
	const originalValue = props.isProtectArea ? Boolean(props.pageFlagStatus?.[Number(current)]) : isPageNotTranslate.value
	if (lastPage.value !== current) {
		if (props.isProtectArea) {
			syncProtectAreaPageFlagState(Number(current))
		} else {
			isPageNotTranslate.value = false
			currentOperatorType.value = ''
			lastPage.value = current
		}
	}
	if(str === 'pageFlag'){
		console.log('是否进入到设置page')
		// pageFlag 模式：切换状态，清空其他类型，并始终派发事件
		// isPageNotTranslate.value = !isPageNotTranslate.value
		currentOperatorType.value = ""

		if (originalValue){
			emit('operatorActive', { action: str, isCurrentlyFlag: true })
		}else{
			emit('operatorActive', { action: str, isCurrentlyFlag: false })
		}

		isPageNotTranslate.value = !originalValue
		
	}else{
		if (props.isProtectArea && originalValue) {
			isPageNotTranslate.value = true
			currentOperatorType.value = ''
			return
		}
		isPageNotTranslate.value = false
		currentOperatorType.value = str
		emit('operatorActive', { action: str })
	}
}
interface EditRectData {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color?: string;
  createdAt: Date;
}
// 获取所有页面绘图数据
async function getAllDrawingsData(): Promise<Record<string, EditRectData[]>> {
  const allDrawings = getAllDrawings()

  // 添加防抖和延迟等待，确保 canvas 初始化完成
  await new Promise(resolve => setTimeout(resolve, 200))

  const result: Record<string, EditRectData[]> = {}

  for (const id in allDrawings) {
    const drawingHook = allDrawings[id];
    if (drawingHook && typeof drawingHook.exportAllData === 'function') {
      const data = await drawingHook.exportAllData();
			// console.log('data===',data)
      // 判断返回是否为数组且元素符合结构
      if (Array.isArray(data)) {
        result[id] = data as EditRectData[];
      } else {
        result[id] = [];
      }
    } else {
      result[id] = [];
    }
  }

  return result
}

// 处理输入时的合法性校验
const handlePageInput = (event: Event) => {
  let value = (event.target as HTMLInputElement).value;
  // 只保留数字
  const num = parseInt(value.replace(/\D/g, ''), 10);
  if (!isNaN(num) && num > 0) {
    currentPage.value = Math.min(num, pages.pageNumber); // 不超过最大页码
  } else {
    currentPage.value = currentPage.value; // 非法输入默认重置为第一页
  }
};

// 输入框失去焦点时触发，防止输入框为空或超出范围
const handlePageBlur = () => {
  if (currentPage.value < 1) {
    currentPage.value = 1;
  } else if (currentPage.value > pages.pageNumber) {
    currentPage.value = pages.pageNumber;
  }
	
  emit('updatePages', { currentPage: Number(currentPage.value) });
};

</script>

<style scoped lang='less'>
.regionalTranslationTopView{
	width: 100%;
	background-color: #fff;
	padding:8px 0;
	.operator_view{
		
		
	}
	.operator_view_left{
		margin-left:50px;
		
		.back {
			display: flex;
			flex-direction: row;
			align-items: center;
			cursor: pointer;
			margin-right: 20px;
			&:hover {
				opacity: 0.6;
			}
			.icon-icon_return {
				font-size: 20px;
				margin-right: 5px;
			}
			.back_text {
				font-size: 14px;
			}
		}
	}
	
	.operator_view_center{
		margin-right:300px;
		flex: 1;
		justify-content: center;
		.pagePDFScala{
			>div{
				margin-right:15px;
			}
			i{
				font-size: 20px;
				padding:0 5px;
				cursor: pointer;
			}
			i:hover{
				opacity: .5;
			}
		}
		.pagePDFMode{
			// margin:0 10px;
			.pagePDFMode_input{
				height:30px;
				width: 40px;
				background-color: transparent ;
				border: 1px solid #bfbfbf ;
				border-radius: 3px ;
				text-align: center;
				margin:0 5px;
			}
		}

		.regionalOperatorMode{
			i{
				font-size: 20px;
				cursor: pointer;
				margin-left:15px;
				padding: 3px 4px;
			}
			.operator_item{
				color: var(--input-bg-color);
			 	// background-color: var(--text-color3);
			 	padding:3px 4px;
			 	border-radius: 3px;
			}
			.iconfontActive{
				background-color: var(--input-bg-color);
				padding: 3px 4px;
				border-radius: 3px;
			}
		}
		
	}
	
	.operator_view_right{
		padding:0 10px;
		margin-left: auto;
		margin-right: 10px;
		cursor: pointer;
		i{
			font-size: 20px;
		}
	}
	.operator_view_right:hover{
		opacity: .5;
	}
	.common_display{
		display: flex;
		align-items: center;
	}

}
</style>
<style>
.pagePDFMode_input:focus {
	outline: none !important;
	box-shadow: none !important;
	border-color: inherit !important;
	/* 可选 - 保持原有边框颜色 */
}
</style>
